document.addEventListener("DOMContentLoaded", function() {
	var accordion = document.querySelectorAll('.accordion-lg__handle');
	var firstAccordionBody = document.querySelector('.accordion-lg__body');
	var currentlyOpenAccordion = firstAccordionBody; // Track currently open accordion

	if (firstAccordionBody) {
		// Initialize first accordion item to be open
		firstAccordionBody.classList.toggle('is-open');
		firstAccordionBody.style.maxHeight = firstAccordionBody.scrollHeight + "px";
	}

	if (accordion.length > 0) {
		accordion[0].classList.toggle('is-active');

		accordion.forEach(function(item) {
			item.addEventListener('click', function() {
				var did = this.getAttribute('aria-controls');
				var target = document.getElementById(did);

				// If the clicked item is already open, toggle it directly
				if (currentlyOpenAccordion === target) {
					this.setAttribute("aria-expanded", "false");
					this.classList.remove('is-active');
					target.classList.remove('is-open');
					target.style.maxHeight = '0';
					currentlyOpenAccordion = null;
				} else {
					// If another accordion is open, wait for it to close before opening the new one
					if (currentlyOpenAccordion) {
						currentlyOpenAccordion.style.maxHeight = '0';
						currentlyOpenAccordion.classList.remove('is-open');
						document.querySelector('.accordion-lg__handle.is-active').classList.remove('is-active');

						// Listen for the closing animation to complete
						currentlyOpenAccordion.addEventListener('transitionend', function handler() {
							// Remove event listener after it's called
							currentlyOpenAccordion.removeEventListener('transitionend', handler);

							// Open the new accordion
							item.setAttribute("aria-expanded", "true");
							item.classList.add('is-active');
							target.classList.add('is-open');
							target.style.maxHeight = target.scrollHeight + "px";
							currentlyOpenAccordion = target;
						}, { once: true });
					} else {
						// If no accordion is open, open the clicked accordion immediately
						item.setAttribute("aria-expanded", "true");
						item.classList.add('is-active');
						target.classList.add('is-open');
						target.style.maxHeight = target.scrollHeight + "px";
						currentlyOpenAccordion = target;
					}
				}
			});
		});
	}

	// Expand all accordions if the "Show All" button is clicked
	var showAll = document.getElementById('toggleAll');
	var accordionBtns = document.querySelectorAll('.accordion-lg__handle');
	var accordionItems = document.querySelectorAll('.accordion-lg__body');

	if (showAll) {
		showAll.addEventListener('click', function(e) {
			e.preventDefault();
			accordionItems.forEach(function(item) {
				item.classList.add('is-open');
				item.style.maxHeight = item.scrollHeight + "px"; // Set max-height to open all
			});
			accordionBtns.forEach(function(btn) {
				btn.setAttribute("aria-expanded", "true");
				btn.classList.add('is-active');
			});
		});
	}

	// Handle opening specific accordion from URL hash
	var getAccordion = window.location.hash.substring(1);
	if (getAccordion.length > 0) {
		var accordionEntry = document.getElementById(getAccordion);
		if (accordionEntry) {
			var did = accordionEntry.getAttribute('aria-controls');
			var target = document.getElementById(did);
			if (target) {
				target.classList.add('is-open');
				target.style.maxHeight = target.scrollHeight + "px"; // Set max-height to open specific accordion
				accordionEntry.setAttribute("aria-expanded", "true");
				accordionEntry.classList.add('is-active');
				currentlyOpenAccordion = target;
			}
		}
	}
});
